import * as React from 'react'
import styled from 'styled-components'
import Accordion from 'theme/molecules/Accordion'
import * as t from './types'
import RawMarkdown from 'theme/atoms/Markdown'
import theme from 'theme'

export default function MarkdownAccordion(props: t.Props) {
  return (
    <Wrapper className="MarkdownAccordion">
      {props.items.map((accordion, i) => {
        return (
          <div className="accordion-container" key={i}>
            <Accordion label={accordion.title}>
              <RawMarkdown html={accordion.md} />
            </Accordion>
          </div>
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > .accordion-container {
    border-top: 1px solid ${theme.colors.shade.b2};
    &:last-child {
      border-bottom: 1px solid ${theme.colors.shade.b2};
    }
  }
`
